"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.foundation_gradient = void 0;
exports.foundation_gradient = {
    direction: {
        gradient_direction_right: '90deg',
        gradient_direction_bottomLeft: '225deg',
        gradient_direction_bottom: '180deg',
        gradient_direction_bottomRight: '135deg',
    },
    style: {
        gradient_style_linear: 'linear',
    }
};
//# sourceMappingURL=global.js.map